/* gldn-wishlist: custom Swym Wishlist Plus client
   Ports the legacy theme's assets/wishlist.js behavior to Horizon.
   Intercepts Swym's native variant-selector popup so users see the theme's
   "Your wishlist / Create New List / List selection / Add note" flow.
*/

(function () {
  /* ------------------------------------------------------------------
     Native <dialog> helper (replaces legacy Simplistic.openModal)
     ------------------------------------------------------------------ */
  let currentDialog = null;

  function openDialog(html, cssClass) {
    if (currentDialog) {
      try { currentDialog.close(); } catch (_) {}
      currentDialog.remove();
      currentDialog = null;
    }

    const dialog = document.createElement('dialog');
    dialog.className = 'gldn-wishlist-dialog ' + (cssClass || '');

    const box = document.createElement('div');
    box.className = 'gldn-wishlist-dialog__box';

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'gldn-wishlist-dialog__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', () => dialog.close());

    const content = document.createElement('div');
    content.className = 'gldn-wishlist-dialog__content';
    content.innerHTML = html;

    box.appendChild(closeBtn);
    box.appendChild(content);
    dialog.appendChild(box);

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      dialog.remove();
      if (currentDialog === dialog) currentDialog = null;
      if (window.gldnWishlistModal === dialog) window.gldnWishlistModal = null;
    });

    document.body.appendChild(dialog);
    dialog.showModal();
    currentDialog = dialog;
    window.gldnWishlistModal = dialog;
    return dialog;
  }

  function closeDialog() {
    if (currentDialog) currentDialog.close();
  }

  /* ------------------------------------------------------------------
     Shared wishlist flow (used by <wishlist-product> + Searchspring)
     ------------------------------------------------------------------ */
  const WishlistFlow = {
    current: null,

    openForProduct(product) {
      this.current = product;
      const swat = window._swat;
      if (!swat || !swat.fetchLists) return;

      swat.fetchLists({
        callbackFn: (lists = []) => {
          if (lists && lists.length > 0) this.showListSelection(lists);
          else this.showFirstScreen(product);
        },
        errorFn: (err) => {
          console.error('Error fetching lists:', err);
          closeDialog();
          alert('Error adding product to list. Please try again. If the problem persists, contact us.');
        },
      });
    },

    showFirstScreen(product) {
      openDialog(
        `
          <div class="modal-header">Your wishlist</div>
          <div class="modal-container">
            <h2>Save this item to your<br> first wishlist</h2>
            <button id="create-new" class="btn v1">Create New List</button>
          </div>
        `,
        'wish-modal-content'
      );
      const btn = document.querySelector('#create-new');
      if (btn) btn.onclick = () => this.showCreateList(product);
    },

    showListSelection(lists) {
      let html = `<div class="modal-header">Your wishlist</div>`;
      html += `<div class="modal-container">`;
      html += `<button id="create-new" class="btn v1">Create New List</button>`;
      html += `<div class="lists-wrapper">`;

      lists.forEach((listItem) => {
        const count = (listItem.listcontents || []).length || 0;
        const img = listItem.lprops?.image
          ? `<div class="img-wrapper"><img src="${listItem.lprops.image}" alt="${listItem.lname || ''}"></div>`
          : '';
        html += `
          <div tabindex="0" class="list-item" data-id="${listItem.lid}">
            ${img}
            <div class="text-wrapper">
              <h3>${listItem.lname || ''}</h3>
              <span class="list-qty">${count} items</span>
            </div>
          </div>
        `;
      });

      html += `</div></div>`;

      openDialog(html, 'wish-modal-content');

      const createBtn = document.querySelector('#create-new');
      if (createBtn) createBtn.onclick = () => this.showCreateList(this.current);

      document.querySelectorAll('.list-item').forEach((item) => {
        const name = item.querySelector('h3')?.textContent || '';
        item.onclick = () => this.showAddNote(this.current, item.dataset.id, name);
      });
    },

    showCreateList(product) {
      openDialog(
        `
          <div class="modal-header">Your wishlist</div>
          <div class="modal-container">
            <div class="create-list-wrapper">
              <div class="img-wrapper">
                <img src="${product?.cprops?.image || ''}" alt="Product">
              </div>
              <label for="new-list-name">New Wishlist</label>
              <input type="text" id="new-list-name" />
              <button id="save-new-list" class="btn v1" disabled>Save</button>
            </div>
          </div>
        `,
        'wish-modal-content'
      );

      const input = document.querySelector('#new-list-name');
      const saveBtn = document.querySelector('#save-new-list');
      if (!input || !saveBtn) return;

      saveBtn.onclick = () => {
        const name = (input.value || '').trim();
        if (!name) return;
        window._swat.createList(
          { lname: name, lprops: { image: product?.cprops?.image || '' } },
          (newList) => this.showAddNote(product, newList.lid, newList.lname),
          (err) => {
            console.error('Error creating list:', err);
            closeDialog();
            alert('Error creating your list. Please try again. If the problem persists, contact us.');
          }
        );
      };

      input.onkeyup = () => {
        const enabled = (input.value || '').trim().length > 3;
        if (enabled) saveBtn.removeAttribute('disabled');
        else saveBtn.setAttribute('disabled', 'true');
      };
    },

    showAddNote(product, lid, listName) {
      const optionsList = (product?.cprops?.options || [])
        .map((opt) => (opt?.value ? `<li>${opt.name}: ${opt.value}</li>` : ''))
        .join('');

      openDialog(
        `
          <div class="modal-header">${listName || 'Your wishlist'}</div>
          <div class="modal-container">
            <div class="product-wrapper">
              <div class="img-wrapper">
                <img src="${product?.cprops?.image || ''}" alt="${product?.dt || ''}">
              </div>
              <h3>${product?.dt || ''}</h3>
              <ul>${optionsList}</ul>
              <label for="note">Add a note to this item:</label>
              <textarea id="note"></textarea>
              <button id="final-save" class="btn v1">Save</button>
            </div>
          </div>
        `,
        'wish-modal-content'
      );

      const saveBtn = document.querySelector('#final-save');
      if (!saveBtn) return;

      saveBtn.onclick = () => {
        const noteEl = document.querySelector('#note');
        product.note = noteEl ? noteEl.value : '';
        setTimeout(() => {
          window._swat.addToList(
            lid,
            product,
            () => {
              window._swat.fetchLists({ callbackFn: () => {}, errorFn: console.error });
              closeDialog();
              setTimeout(() => window.updateAllWishlistProducts?.(), 300);
            },
            (error) => {
              console.error('Error adding product to list:', error);
              closeDialog();
              alert('Error adding product to list. Please try again. If the problem persists, contact us.');
            }
          );
        }, 50);
      };
    },
  };

  /* ------------------------------------------------------------------
     <wishlist-product> custom element (PDP + anywhere the snippet renders)
     ------------------------------------------------------------------ */
  class WishlistProduct extends HTMLElement {
    constructor() {
      super();
      this.initialize();
    }

    connectedCallback() {
      this.initialize();
    }

    initialize() {
      if (this.dataset.gldnWishlistInitialized === 'true') return;

      this.wishBtn = this.querySelector('.wish-trigger');
      this.deleteListsBtn = this.querySelector('.delete-lists');
      this.productId = Number(this.dataset.productId) || null;
      this.variantId = Number(this.dataset.variantId) || null;
      this.productUrl = this.dataset.productUrl || '';
      this.productTitle = this.dataset.productTitle || '';
      this.productImage = this.dataset.productImage || '';
      try {
        this.optionNames = JSON.parse(this.dataset.productOptions || '[]');
      } catch (_) {
        this.optionNames = [];
      }

      // Dynamically-created cards may connect before their trigger is appended.
      if (!this.wishBtn) return;

      this.dataset.gldnWishlistInitialized = 'true';

      /* Reveal immediately — don't depend on fetchLists completing.
         Active-state highlight is applied later by updateAllWishlistProducts. */
      this.wishBtn.style.display = 'block';
      this.wishBtn.addEventListener('click', this.launchWishApp.bind(this));
      if (this.deleteListsBtn) this.deleteListsBtn.addEventListener('click', this.deleteLists.bind(this));
    }

    launchWishApp(event) {
      event?.preventDefault();
      event?.stopPropagation();

      try {
        if (this.wishBtn && this.wishBtn.classList.contains('active')) {
          this.removeProductFromAllLists();
          return;
        }
        this.buildAndOpen();
      } catch (err) {
        console.error('[wishlist] launchWishApp error', err);
      }
    }

    removeProductFromAllLists() {
      const swat = window._swat;
      if (!swat?.fetchLists || !swat?.deleteFromList || !this.productId) return;

      swat.fetchLists({
        callbackFn: (lists = []) => {
          let listsToUpdate = 0;
          let completedDeletions = 0;

          lists.forEach((list) => {
            const items = list.listcontents || [];
            const itemInList = items.find((item) => Number(item.empi) === Number(this.productId));
            if (!itemInList) return;

            listsToUpdate++;
            const productToDelete = { epi: itemInList.epi, empi: itemInList.empi, du: itemInList.du };
            swat.deleteFromList(
              list.lid,
              productToDelete,
              () => {
                completedDeletions++;
                if (completedDeletions === listsToUpdate) {
                  setTimeout(() => window.updateAllWishlistProducts?.(), 500);
                }
              },
              (err) => {
                console.error(`Failed to delete product from list ${list.lid}:`, err);
                completedDeletions++;
                if (completedDeletions === listsToUpdate) {
                  setTimeout(() => window.updateAllWishlistProducts?.(), 500);
                }
              }
            );
          });

          if (listsToUpdate === 0) {
            setTimeout(() => window.updateAllWishlistProducts?.(), 500);
          }
        },
        errorFn: (err) => console.error('Error fetching lists for deletion:', err),
      });
    }

    deleteLists() {
      if (!window._swat?.fetchLists) return;
      window._swat.fetchLists({
        callbackFn: (lists = []) => {
          lists.forEach((list) => {
            window._swat.deleteList(
              list.lid,
              () => console.log(`Deleted list ${list.lid}`),
              (err) => console.error(`Failed to delete list ${list.lid}:`, err)
            );
          });
        },
        errorFn: console.error,
      });
    }

    buildAndOpen() {
      const target = this;
      const isPLP = target.dataset.plp !== undefined;
      let closestForm, currentVariantId, currentVariantTitle, variantOptions, variantImage;

      if (isPLP) {
        closestForm = target.closest('.product-item') || document;
        const wishDataInput = closestForm?.querySelector?.('[name="wishdata"]');
        currentVariantId = wishDataInput?.value
          ? Number(wishDataInput.value)
          : Number(target.dataset.variantId) || null;
        const vtA = wishDataInput?.dataset?.variantTitle || target.dataset.variantTitle || '';
        currentVariantTitle = vtA.split(' / ')[0] || '';
        variantOptions = [{ name: 'Material', value: currentVariantTitle || '' }];
        const activeCircle = closestForm?.querySelector?.('.img.main');
        variantImage = activeCircle?.dataset?.bgset || target.productImage || '';
      } else if (target.closest('product-form-component, .product-information')) {
        /* Horizon PDP: read variant from product-form-component's hidden input */
        closestForm = target.closest('product-form-component, .product-information');
        const currentVariantInput = closestForm?.querySelector?.('input[name="id"]');
        currentVariantId = currentVariantInput?.value
          ? Number(currentVariantInput.value)
          : Number(target.dataset.variantId) || null;

        /* Try to read the currently-selected variant options from the variant picker */
        const pickerOptionNodes = closestForm?.querySelectorAll?.(
          '[data-selected-value], .variant-picker__option [aria-pressed="true"], .variant-picker__option input:checked'
        );
        const selectedValues = [];
        pickerOptionNodes?.forEach((node) => {
          const v = node.dataset?.selectedValue || node.getAttribute?.('aria-label') || node.value;
          if (v) selectedValues.push(v);
        });

        variantOptions = (target.optionNames || []).map((optName, i) => {
          const name = typeof optName === 'object' ? optName.name : optName;
          return { name, value: selectedValues[i] || '' };
        });

        const mainImg =
          closestForm?.querySelector?.('.product-media-container img, product-media-gallery img');
        variantImage = mainImg?.currentSrc || mainImg?.src || target.productImage || '';
      } else {
        variantImage = target.productImage || '';
        try {
          const opts = JSON.parse(target.dataset.productOptions || '[]');
          variantOptions = opts.map((o) =>
            typeof o === 'object' ? { name: o.name, value: '' } : { name: o, value: '' }
          );
        } catch (_) {
          variantOptions = [];
        }
      }

      const effectiveVariantId = currentVariantId || Number(target.variantId) || null;
      const productUrl = (window.location.origin || '') + (target.productUrl || '');

      const product = {
        empi: Number(target.productId) || null,
        epi: Number(effectiveVariantId) || null,
        du: productUrl,
        dt: target.productTitle || '',
        cprops: { options: variantOptions || [], image: variantImage || '' },
      };

      WishlistFlow.openForProduct(product);
    }
  }

  customElements.define('wishlist-product', WishlistProduct);

  /* ------------------------------------------------------------------
     Bridge for Searchspring (collection cards without <wishlist-product>)
     ------------------------------------------------------------------ */
  window.gldnWishlist = {
    openForProductUrl(productUrl, onActiveCb) {
      const swat = window._swat;
      if (!swat?.collectionsApi?.swymFetchProductDetails) return;

      swat.collectionsApi.swymFetchProductDetails(
        productUrl,
        (data) => {
          /* Swym wraps the Shopify product payload under `data.product`.
           * Legacy fallback fields (data.empi, data.dt, etc.) are kept in
           * case a future SDK version flattens the shape. */
          const p = data?.product || data || {};
          const firstVariant = p.variants?.[0] || {};
          const imageSrc =
            data?.cprops?.image ||
            p.image?.src ||
            p.images?.[0]?.src ||
            data?.featured_image ||
            data?.image ||
            '';
          const optionNames = Array.isArray(p.options)
            ? p.options.map((o) => ({ name: o.name, value: '' }))
            : [];
          const product = {
            empi: Number(data?.empi || p.id) || null,
            epi: Number(data?.epi || firstVariant.id) || null,
            du: productUrl,
            dt: data?.dt || p.title || data?.title || '',
            cprops: {
              options: data?.cprops?.options || optionNames,
              image: imageSrc,
            },
          };
          WishlistFlow.openForProduct(product);
        },
        (err) => console.error('Failed to fetch product details:', err)
      );
    },
    flow: WishlistFlow,
    openDialog,
    closeDialog,
  };

  /* ------------------------------------------------------------------
     <wishlist-page> — renders on /pages/wishlist
     ------------------------------------------------------------------ */
  class WishlistPage extends HTMLElement {
    constructor() {
      super();
      this.title = this.dataset.title || 'Your Wishlists';
      this.text = this.dataset.text || 'Keep your favorite pieces close. Find them all right here.';
      this.lists = [];
      this.selectedList = null;
      window.addEventListener('swym:loaded', () => this.init());
    }

    async init() {
      await this.fetchLists();
      this.render();
    }

    async fetchLists() {
      if (!window._swat?.fetchLists) return;
      try {
        const lists = await new Promise((resolve, reject) => {
          window._swat.fetchLists({
            callbackFn: (ls) => resolve(ls || []),
            errorFn: reject,
          });
        });
        this.lists = lists || [];
      } catch (err) {
        console.error('Failed to fetch wishlists', err);
      }
    }

    buildProductUrl(item) {
      let url = item.du || '';
      if (item.epi) {
        const sep = url.includes('?') ? '&' : '?';
        url += sep + 'variant=' + item.epi;
      }
      if (Array.isArray(item.cprops?.options)) {
        const sizeOption = item.cprops.options.find(
          (opt) => opt.name && (opt.name.toLowerCase() === 'size' || opt.name.toLowerCase().includes('size'))
        );
        if (sizeOption?.value) {
          const isCustomSize =
            sizeOption.value.toLowerCase() !== 'custom' &&
            sizeOption.value.toLowerCase() !== 'other' &&
            sizeOption.value.trim() !== '';
          if (isCustomSize) {
            const sep = url.includes('?') ? '&' : '?';
            url += sep + 'size=' + encodeURIComponent(sizeOption.value);
          }
        }
      }
      return url;
    }

    render() {
      const breadcrumb = `<div class="wishlist-breadcrumb one-whole">
        <a href="/pages/wishlist">Home / Wishlists</a>
        ${this.selectedList ? `&nbsp;/ ${this.selectedList.lname}` : ''}
      </div>`;

      let header = ``;
      let content = ``;

      if (this.selectedList) {
        const count = (this.selectedList.listcontents || []).length || 0;
        header = `
          <div class="header-wrapper one-whole flex justify-content-between">
            <div class="wishlist-header">
              <h3>${this.selectedList.lname}</h3>
              <span>${count} item${count === 1 ? '' : 's'} added</span>
            </div>
            <div class="wishlist-actions">
              <button class="btn v4" id="share-wishlist">Share Wishlist</button>
              <button class="btn v4" id="edit-items">Edit Items</button>
            </div>
          </div>
        `;

        content = `
          <div class="wishlist-items">
            ${(this.selectedList.listcontents || [])
              .map(
                (item) => `
              <div class="wishlist-item-card one-quarter small--one-half" data-epi="${item.epi}">
                <a href="${this.buildProductUrl(item)}" class="wishlist-item-link">
                  <div class="img-wrapper">
                    <img src="${item.cprops?.image || ''}" alt="${item.dt || ''}">
                  </div>
                  <div class="price-wrapper flex justify-content-between">
                    <h3>${item.dt || ''}</h3><span class="item-price">${window.Shopify?.formatMoney ? window.Shopify.formatMoney((item.pr || 0) * 100).replace('.00', '') : ''}</span>
                  </div>
                  <ul>${(item.cprops?.options || []).map((opt) => `<li>${opt.name}: ${opt.value}</li>`).join('')}</ul>
                  ${item.note ? '<p>Note:' + item.note + '</p>' : ''}
                </a>
                <div class="wishlist-view-product">
                  <a href="${this.buildProductUrl(item)}" class="btn v4">View Product</a>
                </div>
                <button class="delete-item" style="display:none" type="button" aria-label="Remove item">&#10005;</button>
              </div>
            `
              )
              .join('')}
          </div>
        `;
      } else if ((this.lists || []).length > 0) {
        header = `
          <div class="header-wrapper one-whole flex justify-content-between">
            <div class="wishlist-header">
              <h2>${this.title}</h2>
              <span>${this.text}</span>
            </div>
            <div class="wishlist-actions">
              <button class="btn v4" id="edit-lists">Edit Lists</button>
            </div>
          </div>
        `;
        content = `
          <div class="lists-wrapper flex flex-wrap">
            ${this.lists
              .map(
                (list) => `
              <div tabindex="0" class="list-item one-third medium--one-half small--one-whole" data-list-id="${list.lid}">
                ${list.lprops?.image ? `<div class="img-wrapper"><img src="${list.lprops.image}" alt="${list.lname || ''}"></div>` : ''}
                <div class="text-wrapper">
                  <h3>${list.lname || ''}</h3>
                  <span class="list-qty">${(list.listcontents || []).length || 0} items</span>
                </div>
                <button class="delete-list" style="display:none" type="button" aria-label="Delete list">&#10005;</button>
              </div>
            `
              )
              .join('')}
          </div>
        `;
      } else {
        header = `
          <div class="header-wrapper one-whole flex justify-content-between">
            <div class="wishlist-header">
              <h2>${this.title}</h2>
              <span>${this.text}</span>
            </div>
          </div>
        `;
        content = `<p>You don't have any lists yet.</p>`;
      }

      this.innerHTML = `<div class="container">${breadcrumb}${header}${content}</div>`;
      this.bindEvents();
    }

    bindEvents() {
      if (this.selectedList) {
        this.querySelector('#edit-items')?.addEventListener('click', () => this.toggleDeleteButtons());
        this.querySelector('#share-wishlist')?.addEventListener('click', () => this.openShareModal());
        this.querySelectorAll('.delete-item').forEach((btn) => {
          btn.addEventListener('click', (e) => this.deleteItem(e));
        });
        window.wishlistAddToCartAjax?.();
      } else {
        this.querySelector('#edit-lists')?.addEventListener('click', () => this.toggleDeleteLists());
        this.querySelectorAll('.list-item').forEach((card) => {
          card.addEventListener('click', (e) => {
            if (e.target.classList?.contains('delete-list')) return;
            const listId = card.dataset.listId;
            this.selectedList =
              (this.lists || []).find((l) => String(l.lid) === String(listId)) || null;
            this.render();
          });
        });
        this.querySelectorAll('.delete-list').forEach((btn) => {
          btn.addEventListener('click', (e) => this.deleteList(e));
        });
      }
    }

    toggleDeleteButtons() {
      this.querySelectorAll('.delete-item').forEach((btn) => {
        btn.style.display = btn.style.display === 'none' ? 'inline-block' : 'none';
      });
    }

    toggleDeleteLists() {
      this.querySelectorAll('.delete-list').forEach((btn) => {
        btn.style.display = btn.style.display === 'none' ? 'inline-block' : 'none';
      });
    }

    deleteItem(e) {
      const card = e.target.closest('.wishlist-item-card');
      if (!card) return;
      const epi = Number(card.dataset.epi);
      const item = (this.selectedList?.listcontents || []).find((i) => Number(i.epi) === epi);
      if (!item) return;

      const product = { epi: item.epi, empi: item.empi, du: item.du };
      if (!window._swat?.deleteFromList) return;

      window._swat.deleteFromList(
        this.selectedList.lid,
        product,
        () => {
          this.fetchLists().then(() => {
            this.selectedList =
              (this.lists || []).find((l) => String(l.lid) === String(this.selectedList.lid)) || null;
            this.render();
            // Refresh the nav heart/badge after removing an item here.
            window.updateAllWishlistProducts?.();
          });
        },
        (err) => console.error('Failed to delete item:', err)
      );
    }

    deleteList(e) {
      const card = e.target.closest('.list-item');
      if (!card) return;
      const listId = card.dataset.listId;
      if (!window._swat?.deleteList) return;
      window._swat.deleteList(
        listId,
        () => this.fetchLists().then(() => { this.render(); window.updateAllWishlistProducts?.(); }),
        (err) => console.error('Failed to delete list:', err)
      );
    }

    openShareModal() {
      if (!this.selectedList) return;
      const lid = this.selectedList.lid;
      const fromName = window.shopCustomer?.email || '';

      const html = `
        <div class="modal-header">Share your list &nbsp; <strong>${this.selectedList.lname || ''}</strong></div>
        <div class="modal-container">
          <div class="form-wrapper">
            <label for="sender-email">From:</label>
            <input type="email" id="sender-email" placeholder="Enter your email" ${fromName ? 'value="' + fromName + '"' : ''} />
            <div id="sender-error" class="error-msg"></div>
            <label for="share-email">To:</label>
            <input type="email" id="share-email" placeholder="Enter a friend's email" required />
            <div id="recipient-error" class="error-msg"></div>
            <button class="btn v1" id="send-share" disabled>Send</button>
          </div>
        </div>
      `;

      openDialog(html, 'share-wishlist-modal');

      setTimeout(() => {
        const senderInput = document.querySelector('#sender-email');
        const recipientInput = document.querySelector('#share-email');
        const sendBtn = document.querySelector('#send-share');
        const senderError = document.querySelector('#sender-error');
        const recipientError = document.querySelector('#recipient-error');
        if (!recipientInput || !sendBtn) return;

        const validateEmails = () => {
          let senderValid = true;
          if (!fromName && senderInput) {
            senderValid = !!senderInput.value && senderInput.validity.valid;
            if (senderError) {
              senderError.textContent =
                senderValid || !senderInput.value ? '' : 'Please enter a valid sender email';
            }
          }
          const recipientValid = !!recipientInput.value && recipientInput.validity.valid;
          if (recipientError) {
            recipientError.textContent =
              recipientValid || !recipientInput.value ? '' : 'Please enter a valid recipient email';
          }
          sendBtn.disabled = !(senderValid && recipientValid);
        };

        senderInput?.addEventListener('input', validateEmails);
        recipientInput.addEventListener('input', validateEmails);

        sendBtn.addEventListener('click', () => {
          const email_sender = senderInput?.value || fromName || '';
          const email = recipientInput.value || '';
          if (!email) return;
          if (!window._swat?.markListPublic || !window._swat?.sendListViaEmail) return;

          window._swat.markListPublic(
            lid,
            () => {
              window._swat.sendListViaEmail(
                {
                  toEmailId: email,
                  fromName: email_sender,
                  note: `Hey, check out my wishlist: ${this.selectedList.lname}!`,
                  lid: lid,
                  cprops: {},
                },
                () =>
                  openDialog(
                    `<div class="modal-header">SUCCESS</div>
                     <div class="modal-container">
                       <em>Your list has been shared successfully!</em>
                     </div>`,
                    'share-wishlist-modal'
                  ),
                (err) => console.error('Failed to share wishlist via email:', err)
              );
            },
            () => alert('Could not mark the wishlist as public. Try again later.')
          );
        });

        validateEmails();
      }, 0);
    }
  }

  customElements.define('wishlist-page', WishlistPage);

  /* ------------------------------------------------------------------
     <wishlist-shared-list>
     ------------------------------------------------------------------ */
  class WishlistSharedList extends HTMLElement {
    constructor() {
      super();
      window.addEventListener('swym:loaded', () => this.loadSharedList());
    }

    getUrlParams() {
      const params = new URLSearchParams(window.location.search);
      return { hkey: params.get('hkey'), lid: params.get('lid') };
    }

    buildProductUrl(item) {
      let url = item.du || '';
      if (item.epi) {
        const sep = url.includes('?') ? '&' : '?';
        url += sep + 'variant=' + item.epi;
      }
      if (Array.isArray(item.cprops?.options)) {
        const sizeOption = item.cprops.options.find(
          (opt) => opt.name && (opt.name.toLowerCase() === 'size' || opt.name.toLowerCase().includes('size'))
        );
        if (sizeOption?.value) {
          const isCustomSize =
            sizeOption.value.toLowerCase() !== 'custom' &&
            sizeOption.value.toLowerCase() !== 'other' &&
            sizeOption.value.trim() !== '';
          if (isCustomSize) {
            const sep = url.includes('?') ? '&' : '?';
            url += sep + 'size=' + encodeURIComponent(sizeOption.value);
          }
        }
      }
      return url;
    }

    async loadSharedList() {
      const { lid } = this.getUrlParams();
      if (!lid) {
        this.innerHTML = '<p>Invalid shared wishlist link.</p>';
        return;
      }
      if (!window._swat?.fetchListCtx) {
        this.innerHTML = '<p>Failed to load shared wishlist.</p>';
        return;
      }

      try {
        await window._swat.fetchListCtx(
          { lid },
          (listContents) => {
            if (!listContents || listContents.length === 0) {
              this.innerHTML = '<p>No items in this wishlist.</p>';
            } else {
              this.render(listContents);
            }
          },
          () => {
            this.innerHTML = '<p>Failed to load shared wishlist.</p>';
          }
        );
      } catch {
        this.innerHTML = '<p>Failed to load shared wishlist.</p>';
      }
    }

    render(listContents) {
      if (!listContents || listContents.length === 0) {
        this.innerHTML = '<p>No items in this wishlist.</p>';
        return;
      }

      const title = `Hey there! Check out My Shared Wishlist`;
      const items = listContents
        .map(
          (item) => `
            <div class="wishlist-item-card" data-epi="${item.epi}">
              <wishlist-product
                data-product-id="${item.empi}"
                data-variant-id="${item.epi}"
                data-variant-title="${item.dt}"
                data-product-url="${item.du}"
                data-product-title="${item.dt}"
                data-product-price="${item.pr}"
                data-product-image="${item.cprops?.image || ''}"
                data-product-options='${JSON.stringify(item.cprops?.options || [])}'>
                <div tabindex="0" class="wish-trigger">
                  <span class="sr-only">Add to Wishlist</span>
                </div>
              </wishlist-product>
              <a href="${this.buildProductUrl(item)}" class="wishlist-item-link">
                <div class="img-wrapper">
                  <img src="${item.cprops?.image || ''}" alt="${item.dt || ''}">
                </div>
                <div class="price-wrapper flex justify-content-between">
                  <h3>${item.dt || ''}</h3><span class="item-price">${window.Shopify?.formatMoney ? window.Shopify.formatMoney((item.pr || 0) * 100).replace('.00', '') : ''}</span>
                </div>
                <ul>${(item.cprops?.options || []).map((opt) => `<li>${opt.name}: ${opt.value}</li>`).join('')}</ul>
                ${item.note ? '<p>Note:' + item.note + '</p>' : ''}
              </a>
              <div class="wishlist-view-product">
                <a href="${this.buildProductUrl(item)}" class="btn v4">View Product</a>
              </div>
            </div>
          `
        )
        .join('');

      this.innerHTML = `
        <div class="container">
          <div class="header-wrapper one-whole flex justify-content-center">
            <div class="wishlist-header"><h2 class="text-center">${title}</h2></div>
          </div>
          <div class="wishlist-items">${items}</div>
        </div>
      `;
      window.wishlistAddToCartAjax?.();
    }
  }

  customElements.define('wishlist-shared-list', WishlistSharedList);

  /* ------------------------------------------------------------------
     Swym readiness signal + button-state refresh
     ------------------------------------------------------------------ */
  (function () {
    const isSwymReady = () => !!window._swat;
    const trigger = () => window.dispatchEvent(new Event('swym:loaded'));

    if (isSwymReady()) {
      trigger();
      return;
    }

    const observer = new MutationObserver(() => {
      if (isSwymReady()) {
        observer.disconnect();
        clearInterval(interval);
        trigger();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    const interval = setInterval(() => {
      if (isSwymReady()) {
        clearInterval(interval);
        observer.disconnect();
        trigger();
      }
    }, 300);

    setTimeout(() => {
      observer.disconnect();
      clearInterval(interval);
    }, 30000);
  })();

  (function () {
    const debounce = (fn, wait) => {
      let t;
      return function (...args) {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    };

    /* Extract the product handle from a Shopify product URL, ignoring origin,
       collection prefix, query string, and hash. Used to correlate Searchspring
       heart buttons (which only know their product URL, not an empi) with
       wishlist items. */
    const handleFromUrl = (url) => {
      const m = String(url || '').match(/\/products\/([^/?#]+)/);
      return m ? m[1].toLowerCase() : null;
    };

    const _update = () => {
      if (!window._swat) return;
      /* Run when ANY wishlist surface is present: the PDP custom element, a
         Searchspring-injected heart on a PLP, or the nav wishlist heart in the
         header. The original guard bailed unless a <wishlist-product> existed,
         so Searchspring PLPs and header-only pages (homepage, cart, …) never
         got their hearts/badge reconciled. */
      const hasWishlistProducts = !!document.querySelector('wishlist-product');
      const hasSearchspringHearts = !!document.querySelector('.swym-wishlist-collections-v2');
      const hasNavHeart = !!document.querySelector('.gldn-wishlist-link');
      if (!hasWishlistProducts && !hasSearchspringHearts && !hasNavHeart) return;

      window._swat.fetchLists({
        callbackFn: (lists = []) => {
          /* Index list membership two ways — by numeric product id (empi) for
             <wishlist-product> elements, and by product handle (derived from
             each item's display URL) for Searchspring hearts — and tally the
             total item count for the nav-heart badge. */
          const productIdsInLists = new Set();
          const productHandlesInLists = new Set();
          let totalItemCount = 0;
          lists.forEach((list) => {
            const contents = list.listcontents || [];
            totalItemCount += contents.length;
            contents.forEach((item) => {
              productIdsInLists.add(Number(item.empi));
              const handle = handleFromUrl(item.du);
              if (handle) productHandlesInLists.add(handle);
            });
          });

          document.querySelectorAll('wishlist-product').forEach((el) => {
            const pid = Number(el.dataset.productId);
            const wishBtn = el.querySelector('.wish-trigger');
            if (!wishBtn || Number.isNaN(pid)) return;
            if (productIdsInLists.has(pid)) wishBtn.classList.add('active');
            else wishBtn.classList.remove('active');
          });

          /* Searchspring PLP cards: the heart is the button itself, identified
             by the product URL stored in data-product-id. */
          document.querySelectorAll('.swym-wishlist-collections-v2').forEach((btn) => {
            const handle = handleFromUrl(btn.getAttribute('data-product-id'));
            if (!handle) return;
            const active = productHandlesInLists.has(handle);
            btn.classList.toggle('active', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          // Nav heart: filled icon + count badge reflect the total number of
          // wishlisted items across all lists. Re-query here so a header
          // injected after _update started is still picked up. Cap the badge
          // text at 99+ to mirror the cart bubble and avoid overflow.
          const badgeText = totalItemCount > 99 ? '99+' : String(totalItemCount);
          document.querySelectorAll('.gldn-wishlist-link').forEach((link) => {
            link.classList.toggle('has-items', totalItemCount > 0);
            const badge = link.querySelector('.gldn-wishlist-badge');
            if (badge) badge.textContent = totalItemCount > 0 ? badgeText : '';
          });
        },
        errorFn: console.error,
      });
    };

    window.updateAllWishlistProducts = debounce(_update, 200);
  })();

  window.addEventListener('swym:loaded', () => window.updateAllWishlistProducts?.());
  document.addEventListener('gridUpdate', () => window.updateAllWishlistProducts?.());
})();
